import classNames from 'classnames';
import { useField } from 'formik';
import { useCallback, useMemo } from 'react';
import Select from 'react-select';
import './OpinionFilterSortSelectField.css';

export type OpinionFilterSortSelectFieldProps = {
  className?: string;
}

const OPTIONS = [
  { value: "createdAt", label: '최신순' },
  { value: "likesCount", label: '인기순' },
];

export const OpinionFilterSortSelectField = ({ className }: OpinionFilterSortSelectFieldProps) => {
  const [fields, , helpers] = useField('sort');
  const onChange = useCallback(({ value }) => {
    helpers.setValue(value);
  }, [helpers]);
  const value = useMemo(() => OPTIONS.find(({ value }) => value === fields.value ), [fields.value]);

  return (
    <Select
      className={classNames('opinion-filter-sort-select', className)}
      isSearchable={false}
      value={value}
      onChange={onChange}
      options={OPTIONS}
    />
  );
};
